import { useEffect, useState } from "react";

let globalOfficeInitialized = false;

export function officeInitialized() {
  globalOfficeInitialized = true;
  window.dispatchEvent(new Event("office.initialized"));
}

/**
 * Hook to check if Office.js has been initialized.
 *
 * This only includes:
 * - Office.js API availability
 * - Platform detection
 * - Basic Office context setup
 */
export const useOfficeInitialized = () => {
  const [initialized, setInitialized] = useState(globalOfficeInitialized);

  useEffect(() => {
    if (globalOfficeInitialized) setInitialized(true);

    const handleInitialized = () => setInitialized(true);
    window.addEventListener("office.initialized", handleInitialized);
    return () => window.removeEventListener("office.initialized", handleInitialized);
  }, []);

  return initialized;
};
